import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      formConfig: _ctx.formConfig,
      onQueryBtnClick: _ctx.handleQueryClick,
      onResetBtnClick: _ctx.handleQueryClick
    }, null, 8, ["formConfig", "onQueryBtnClick", "onResetBtnClick"]),
    _createVNode(_component_PageContent, {
      ref: "pageContentRef",
      contentConfig: _ctx.contentConfig,
      pageName: "users",
      onEditBtnClick: _ctx.handleEditData,
      onNewBtnClick: _ctx.handleNewData
    }, null, 8, ["contentConfig", "onEditBtnClick", "onNewBtnClick"]),
    _createVNode(_component_PageModal, {
      ref: "pageModalRef",
      pageName: "users",
      defaultInfo: _ctx.defaultInfo,
      modalConfig: _ctx.modalConfigRef,
      onAfterCreateData: _ctx.handleResetClick,
      onAfterdeleteData: _ctx.handleResetClick
    }, null, 8, ["defaultInfo", "modalConfig", "onAfterCreateData", "onAfterdeleteData"])
  ]))
}